<template>
  <div class="d-flex flex-column align-center justify-center multiple-question-box">
    <div class="question-text mb-2">
      {{ question.text }}
    </div>
    <div class="mb-2">
      <v-chip
        :color="allSelected ? '#df0100' : ''"
        :text-color="allSelected ? '#FFFFFF' : '#000000'"
        :outlined="!allSelected"
        class="all-select-chip d-flex align-center justify-center"
        @click="toggleAll"
      >
        <v-simple-checkbox
          :value="allSelected"
          :ripple="false"
          class="simple-check"
          @click="toggleAll"
        />
        <div>
          Selectati toti anii
        </div>
      </v-chip>
    </div>

    <div class="d-flex align-center justify-center flex-wrap">
      <div v-for="option in items" :key="option.id" class="option-chip-box ma-1">
        <v-chip
          class="option-chip d-flex align-center justify-center"
          :color="checkIsSelected(option) ? '#df0100' : ''"
          :text-color="checkIsSelected(option) ? '#FFFFFF' : '#000000'"
          :outlined="!checkIsSelected(option)"
          @click="toggleAnswer(option)"
        >
          <v-simple-checkbox
            :value="checkIsSelected(option)"
            :ripple="false"
            class="simple-check"
            @click="toggleAnswer(option)"
          />
          {{ option.text }}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultipleQuestion',
  props: {
    question: {
      type: Object,
      required: true
    },
    currentAnswer: {
      type: Object,
      default: null
    },
    parentAnswer: {
      type: Object,
      default: null
    },
    answers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedAnswers: this.currentAnswer?.ids || []
    };
  },
  computed: {
    items() {
      // Show only valid possible RCA years based on license years
      const typeOfOwnerAnswer = this.answers.find(el => el.questionId === 2) || 0;
      const licenseYears = typeOfOwnerAnswer?.id === 1 ? this.answers.find(el => el.questionId === 7)?.years || 0 : 11;
      const currentYear = new Date().getFullYear();
      return this.question.options.filter(el => {
        return parseInt(el.id) >= currentYear - licenseYears;
      }) || [];
    },
    allSelected() {
      return this.selectedAnswers.length === this.items.length;
    }
  },
  watch: {
    parentAnswer() {
      this.selectedAnswers = [];
    }
  },
  methods: {
    checkIsSelected(option) {
      return this.selectedAnswers.includes(option.id);
    },
    toggleAll() {
      if (this.allSelected) {
        this.selectedAnswers = [];
      } else {
        this.selectedAnswers = this.items.map(el => el.id);
      }
      this.updateSelection();
    },
    toggleAnswer(option) {
      if (!this.selectedAnswers.includes(option.id)) {
        this.selectedAnswers.push(option.id);
      } else {
        this.selectedAnswers = this.selectedAnswers.filter(el => el !== option.id);
      }
      this.updateSelection();
    },
    updateSelection() {
      setTimeout(() => {
        if (this.selectedAnswers.length > 0) {
          this.$emit('updateAnswer', {
            questionId: this.question.id,
            questionText: this.question.text,
            isBonus: this.question.isBonus,
            bonusValue: this.selectedAnswers.length,
            ids: JSON.parse(JSON.stringify(this.selectedAnswers))
          });
        } else {
          this.$emit('removeAnswer', this.question.id);
        }
      }, 200);
    }
  }
};
</script>

<style scoped>
.option-chip-box {
  min-width: 105px;
}
.option-chip {
  width: 100%;
}
.question-text {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
.all-select-chip {
  width: 330px;
}
@media screen and (max-width: 600px) {
  .all-select-chip {
    width: 260px;
  }
  .option-chip-box {
    min-width: 122px;
  }
}
.multiple-question-box {
  width: 355px;
}
/*.multiple-question-box ::v-deep .v-input--radio-group__input {*/
/*  justify-content: center;*/
/*}*/
@media screen and (max-width: 600px) {
  .multiple-question-box {
    width: 260px !important;
  }
}
.simple-check ::v-deep .v-icon {
  font-size: 20px;
}
</style>
